module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "展示方式"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.btn_show_type),
      expression: "form.btn_show_type"
    }],
    domProps: {
      "value": (_vm.form.btn_show_type)
    },
    on: {
      "input": function($event) {
        _vm.form.btn_show_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("按钮形式")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("表格形式")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "嵌入功能点"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "data": _vm.form.deals
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "功能点",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.id),
            expression: "scope.row.id"
          }],
          domProps: {
            "value": (scope.row.id)
          },
          on: {
            "input": function($event) {
              scope.row.id = $event
            }
          }
        }, _vm._l((_vm.deals), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.name,
              "value": option.id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "按钮颜色",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.btn_color),
            expression: "scope.row.btn_color"
          }],
          domProps: {
            "value": (scope.row.btn_color)
          },
          on: {
            "input": function($event) {
              scope.row.btn_color = $event
            }
          }
        }, _vm._l((_vm.btnColors), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.name,
              "value": option.id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "字体颜色",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.font_color),
            expression: "scope.row.font_color"
          }],
          domProps: {
            "value": (scope.row.font_color)
          },
          on: {
            "input": function($event) {
              scope.row.font_color = $event
            }
          }
        }, _vm._l((_vm.fontColors), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.name,
              "value": option.id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticClass: "p-t-10 p-b-10"
        }, [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": scope.$index == 0
          },
          on: {
            "click": function($event) {
              _vm.sortUp(scope.$index)
            }
          }
        }, [_vm._v("上移")])]), _vm._v(" "), _c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": scope.$index == _vm.form.deals.length - 1
          },
          on: {
            "click": function($event) {
              _vm.sortDown(scope.$index)
            }
          }
        }, [_vm._v("下移")])]), _vm._v(" "), _c('span', [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteDeal(scope.$index)
            }
          }
        }, [_vm._v("删除")])])])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c",
    staticStyle: {
      "width": "800px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDeal
    }
  }, [_vm._v("添加一个")])])])])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3648e5d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/dealGroupConfig.vue
// module id = 1820
// module chunks = 2